module.exports = __webpack_public_path__ + "img/chinesecompany23.c31671ad.png";